import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  colorBox:{
    display: "inline-block",
    height: "14px",
    width: "14px",
    minHeight: "14px",
    minWidth: "14px",
    border: "solid 1px black"
  },
}));

export default useStyles;
